export default "__VITE_ASSET__iwzursTn__"